import { useState } from 'react';
import { useSiteContent } from '../context/SiteContentContext';
import { useShippingZones } from '../lib/storeData';
import GuyanaStripe from '../components/layout/GuyanaStripe';
import PageTitle from '../components/ui/PageTitle';
import './PoliciesPage.css';

export default function PoliciesPage() {
  var content = useSiteContent();
  var c = content.c;
  var _activeTab = useState('returns');
  var activeTab = _activeTab[0]; var setActiveTab = _activeTab[1];
  var zones = useShippingZones().zones;

  var tabs = [
    { id: 'returns', label: 'Returns & repairs' },
    { id: 'shipping', label: 'Shipping' },
    { id: 'privacy', label: 'Privacy' },
  ];

  return (
    <>
      <PageTitle title="Policies" />
      <section className="pol-hero page-band">
        <h1 className="pol-hero__headline page-band__title">Policies</h1>
      </section>

      <GuyanaStripe />

      <div className="container container--reading pol-body">
      <div className="pol-tabs">
        {tabs.map(function(tab) {
          return (
            <button key={tab.id} className={'pol-tab' + (activeTab === tab.id ? ' pol-tab--active' : '')} onClick={function() { setActiveTab(tab.id); }}>
              {tab.label}
            </button>
          );
        })}
      </div>

      <div className="pol-content">
        {activeTab === 'returns' && (
          <div className="pol-section">
            <div className="pol-highlight">{c('policy_returns_highlight')}</div>
            <h3>Made-to-order items</h3>
            <p>{c('policy_returns_mto')}</p>
            <h3>Damaged or defective</h3>
            <p>{c('policy_returns_damaged')}</p>
            <h3>Repairs</h3>
            <p>{c('policy_returns_repairs')}</p>
            <h3>Cancellations</h3>
            <p>{c('policy_returns_cancel')}</p>
          </div>
        )}

        {activeTab === 'shipping' && (
          <div className="pol-section">
            <div className="pol-highlight">{c('policy_shipping_highlight')}</div>
            <p>{c('policy_shipping_body')}</p>
            <h3>Shipping rates</h3>
            <div className="pol-table-wrap">
            <table className="pol-table">
              <thead><tr><th>Region</th><th>Standard</th><th>Express</th><th>Delivery</th></tr></thead>
              <tbody>
                {zones.map(function(zone) {
                  return (
                    <tr key={zone.id}>
                      <td><strong>{zone.name}</strong></td>
                      <td>{'$' + zone.standard_rate}</td>
                      <td>{'$' + zone.express_rate}</td>
                      <td>{zone.standard_estimate}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
            <p className="pol-note">{'Orders over $' + c('free_shipping_threshold', '500') + ' ship free worldwide.'}</p>
          </div>
        )}

        {activeTab === 'privacy' && (
          <div className="pol-section">
            <p>{c('policy_privacy')}</p>
          </div>
        )}
      </div>
      </div>
    </>
  );
}